import React, { useMemo, useState } from 'react';
import { Link, useNavigation } from 'react-navi';
import { EntryCard, NavBar } from '@contest-web/components/src/components';
import { Helmet } from 'react-navi-helmet-async';

function RizeClinic() {
    let navigation = useNavigation();
  return (
    <div>
      <Helmet>
        <meta
          content={`セミファイナル 特別協賛審査 詳細決定 | ${process.env.REACT_APP_WEBSITE_NAME}`}
          property="og:title"
        />
        <meta content={`${process.env.REACT_APP_URL}/news/2019-10-15`} property="og:url" />
      </Helmet>
      <div className="hero">
        <div className="hero-head">
          <NavBar logoImageSrc="/images/logo_black.svg" />
        </div>
      </div>
      <section className="section is-padding-bottom-0">
        <div className="container">
          <nav className="breadcrumb is-right is-small-mobile" aria-label="breadcrumbs">
            <ul className="is-align-center">
              <li>
                <Link className="has-text-primary" href="/top">
                  TOP
                </Link>
              </li>
              <li className="is-active">
                <Link href={`/news/2019-10-15`} aria-current="page">
                  セミファイナル 特別協賛審査 詳細決定
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </section>
      <section className="section">
        <div className="container is-small">
          <div className="content" style={{ lineHeight: 2 }}>
            <h3>セミファイナル 特別協賛審査 詳細決定</h3>
            <p style={{ wordBreak: 'break-all' }}>
              この度、セミファイナル期間「特別協賛審査」として
              <br />
              特別協賛の医療脱毛専門の「リゼクリニック・メンズリゼ」様（
              <a className="has-text-primary" href="https://www.rizeclinic.com/missmrcampus2019/" target="_blank">
                https://www.rizeclinic.com/missmrcampus2019/
              </a>
              ) とのコラボ企画を開催致します。
            </p>
            <p>
              「#リゼクリニックの日」プロジェクトと題し
              10月16日「リゼクリニックの日」にちなんで、期間中セミファイナリストがハッシュタグ「#リゼクリニックの日」とともに、肌をアピールした写真をツイートし、そのツイートのRT数を競います。
              <br />
            </p>
            <p>期間中最もRT数が多かった1名には、当コンテストのファイナリストとして選出致します。</p>
            <p>※ 不正と思われるRT数は対象外と致します。</p>
            <div>
              <table className="table">
                <tbody>
                  <tr>
                    <th>期間</th>
                  </tr>
                  <tr>
                    <td>10月16日(水)11:00～10月20日(日)23:59</td>
                  </tr>
                </tbody>
              </table>
              <table className="table">
                <tbody>
                  <tr>
                    <th className="is-narrow">リゼクリニックの日とは</th>
                  </tr>
                  <tr>
                    <td>
                      脱毛には「医療脱毛」と「エステ脱毛」の2種類がありますが、約80%の女性がこれらの違いを知らないことから、医療脱毛を提供するリゼクリニックを通して、医療脱毛についてもっと知ってもらうことを目的とし、「リゼクリニックの日」を制定。
                      日付は数字の１の形を体毛に見立て、それが脱毛で無くなることを0として10月。「医療＝いりょう」の語感が16と似ていることから16日。合わせて10月16日としたもの。
                      <br />
                      <br />
                      また、抽選で10名様に全身脱毛無料券が当たるチャンスも！
                      <br />
                      詳細は以下特設サイトをご覧くださいませ。
                      <br />
                      ▼ 特設サイト
                      <br />
                      <a
                        className="has-text-primary"
                        href="https://www.rizeclinic.com/rizeclinic-day.html"
                        target="_blank"
                      >
                        https://www.rizeclinic.com/rizeclinic-day.html
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <hr />
            </div>
          </div>
            <p className="title is-size-5 has-text-centered">「#リゼクリニックの日」RT企画1位</p>
            <div>
                <div className="columns is-variable is-multiline is-mobile is-mobile-2 is-margin-bottom-4 is-centered">
                    <div className="column is-one-third-desktop is-one-third-tablet is-half-mobile">
                        <EntryCard
                            onClick={async() => {
                                navigation.navigate(`/profile/${211}`);
                            }}
                            lazy
                            entryNumber={211}
                            name={'渡辺萌菜'}
                            college={'中央大学'}
                            twitter={'frecam19_211'}
                            instagram={'moena._.w'}
                        />
                    </div>
                </div>
            </div>

        </div>
      </section>
    </div>
  );
}

export default RizeClinic;
